module.exports = __webpack_public_path__ + "media/images/1img-309ce750856f244fa451730c47281eff.jpeg";